import { render } from "./NewBomValidationForm.vue?vue&type=template&id=3ed6b780"
import script from "./NewBomValidationForm.vue?vue&type=script&lang=js"
export * from "./NewBomValidationForm.vue?vue&type=script&lang=js"

import "./NewBomValidationForm.vue?vue&type=style&index=0&id=3ed6b780&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField});
